import React from 'react'
import { t } from 'ttag'
import { actions as formActions } from 'react-redux-form'
import { connect } from 'react-redux'

import ActionButton from '../../../components/ActionButton'
import { receivedResponse } from '../../../h2Api'
import Form from '../../../components/form/Form.js'
import Field from '../../../components/form/Field.js'
import { getIntakeMeta, setAdditionalJson } from '../../../actions/profileIntakeActions'
import * as v from '../../../components/form/validations'

const model = 'localOpportunities.profileLoad.form'
const PrePopulateProfileIntakeForm = ({ dispatch, formRequest: request, result }) => {
  return (
    <Form
      model={model}
      key="intake-form"
      onSubmit={p => {
        dispatch(getIntakeMeta(p))
          .then(v => {
            if (!v.hasOwnProperty('error')) {
              ;(result.sectionToMetaMappings || []).map(r => {
                Object.keys(r).map(mp => {
                  const metaKey = r[mp]
                  const metaVal = Array.isArray(metaKey)
                    ? metaKey.map(m => eval(`v.${m}`)).join(' ')
                    : eval(`v.${metaKey}`)

                  dispatch(formActions.change(`${model}.${mp}`, metaVal))
                })
              })
              const socialFields = {
                twitter: v.twitter && v.twitter.handle,
                logoUrl: (v.twitter && v.twitter.avatar) || v.logo,
                facebook: v.facebook && v.facebook.handle,
                linkedIn: v.linkedin && v.linkedin.handle,
                title: v.legalName
              }

              dispatch(formActions.merge(model, socialFields))
              dispatch(setAdditionalJson(v))
            } else {
              dispatch(setAdditionalJson({ doBypass: true }))
            }
          })
          .catch(e => dispatch(setAdditionalJson({ doBypass: true })))
      }}>
      {form => (
        <div className="section">
          <h3>
            <span className="title">{t`Company Information`}</span>
          </h3>
          <div className="row">
            <div className="col-xs-12">
              <p>
                Let's start by collecting the company's URL. If we can, we'll use it to
                pull in some pre-populated information about the company.{' '}
              </p>
            </div>
            <div className="col-xs-12">
              <Field
                model={`${model}.url`}
                className="form-control input-lg"
                form={form}
                type="text"
                label="Company URL"
              />
            </div>
          </div>

          <div className="nav" style={{ marginTop: '25px' }}>
            <ActionButton
              className="btn btn-success"
              loading={request.loading}
              error={request.error}
              success={receivedResponse(request) && t`Created`}>
              {t`Next Step`}
            </ActionButton>
          </div>
        </div>
      )}
    </Form>
  )
}

export default connect(
  state => {
    return {
      ...state.localOpportunities.profileLoad
    }
  },
  dispatch => ({
    dispatch
  })
)(PrePopulateProfileIntakeForm)
